export default "__VITE_ASSET__DXmeLvlY__"